import styles from "./ModalScreenTitle.module.scss";

const SubScreenTitle = ({ children }) => {
  return (
    <section className={" "}>
      <h2 className={styles.modalscreentitle}>{children}</h2>
    </section>
  );
};
export default SubScreenTitle;
